import React, { Component } from 'react';
import './../../css/master.css';
import './adminDashboard.css';

import axiosInstance from '../../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import CountData from './countData';

var httpURL = '';
var queryString = require('querystring');
let lstMachineData = [];
let workDoneSeries = [];
let lstValue = [];
let lstLabel = [];
let lstRejectionValue = [];
let lstMachineLabel = [];
let lstRejectionLabel = [];

class AdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flg: true,
            loader: 'none',
            opacity: 1,
            minDate: null,
            newIpoOption: {},
            newIpoSeries: [],
            rejectionOption: {},
            rejectionSeries: [],
            workDoneOption: {},
            workDoneSeries: [],
            countNewIpo: 5,
            countRejectYardage: 11,
            workDoneCount: 20,
            duration: "weekly",
            xAxis: 'Weeks'
        }

    }
    async componentDidMount() {
        this.setDurationWeekly();
    }

    setDurationWeekly = async () => {
        $('.weekly').addClass('selected');
        $('.monthly').removeClass('selected');
        await this.setState({
            duration: "weekly",
            xAxis: 'Weeks'
        });
        this.getNewIpoData();
        this.getRejectionData();
        this.getWorkDoneData();
    }
    setDurationMonthly = async () => {
        $('.weekly').removeClass('selected');
        $('.monthly').addClass('selected');
        await this.setState({
            duration: "monthly",
            xAxis: 'Months'
        });
        this.getNewIpoData();
        this.getRejectionData();
        this.getWorkDoneData();
    }

    getNewIpoData = async () => {
        this.setState({ loader: 'block', opacity: 0.5 });
        await axiosInstance.post(httpURL+'/a/report/admn_dashboard/new_ipo/graph',
            queryString.stringify({ 'duration': this.state.duration }), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                lstLabel = response.data.lstLabel;
                lstValue = response.data.lstValue;

                this.setState({
                    newIpoSeries: [{
                        name: 'New Ipo',
                        type: 'column',
                        data: lstValue
                    }],
                    newIpoOption: {
                        chart: {
                            height: 500,
                            type: 'column',
                            toolbar: {
                                show: false,
                            }
                        },
                        stroke: {
                            width: 2,
                            show: false,
                            dashArray: 0,
                            lineCap: 'butt',
                        },
                        legend: {
                            show: true,
                            showForSingleSeries: false,
                            showForNullSeries: false,
                            showForZeroSeries: true,
                            position: 'top',
                            horizontalAlign: 'center',
                            floating: false,
                            fontSize: '14px',
                            fontWeight: 400,
                            markers: {
                                width: 25,
                                height: 12,
                                strokeWidth: 0,
                                strokeColor: '#fff',
                                radius: 12,
                                offsetX: 0,
                                offsetY: 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 5
                            },
                        },

                        markers: {
                            size: 2,
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                startingShape: 'flat',
                                endingShape: 'flat',
                                columnWidth: '40%',
                                distributed: false,
                                rangeBarOverlap: true,
                                rangeBarGroupRows: false,
                                colors: {
                                    ranges: [{
                                        from: 0,
                                        to: 0,
                                    }],
                                    backgroundBarColors: [],
                                    backgroundBarOpacity: 1,
                                    backgroundBarRadius: 0,
                                },
                                dataLabels: {
                                    enabled: false,
                                    position: 'top',
                                    offsetY: -100,
                                    style: {
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        colors: '#000'

                                    },
                                },
                            }
                        },
                        xaxis: {
                            categories: lstLabel,
                            labels: {
                                rotate: -45,
                                show: true,

                            },
                            axisTicks: {
                                show: false,
                            },
                            title: {
                                text: this.state.xAxis,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                        },
                        yaxis: [{
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#000'
                            },
                            labels: {
                                style: {
                                    color: '#000',
                                    fontSize: 13
                                }
                            },
                            title: {
                                text: 'Count',
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                            tooltip: {
                                enabled: false
                            }

                        }]
                    },

                    countNewIpo: response.data.countNewIpo,
                });
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg === 'You are not logged in') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
                else if (response.data.SvcMsg === 'Your Session is expired, login again') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            this.setState({ loader: 'none', opacity: 1 });
            toast.error("Service failed " + error);
        });
    }

    getRejectionData = async () => {
        this.setState({ loader: 'block', opacity: 0.5 });
        await axiosInstance.post(httpURL+'/a/report/admn_dashboard/reject_yardage/graph',
            queryString.stringify({ 'duration': this.state.duration }), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                lstRejectionLabel = response.data.lstLabel;
                lstRejectionValue = response.data.lstValue;
                console.log(lstRejectionValue);

                this.setState({
                    rejectionSeries: [{
                        name: 'Rejection',
                        type: 'column',
                        data: lstRejectionValue
                    }],
                    rejectionOption: {
                        chart: {
                            height: 500,
                            type: 'column',
                            toolbar: {
                                show: false,
                            }
                        },
                        stroke: {
                            width: [2,],
                            show: false,
                            dashArray: 0,
                            lineCap: 'butt',
                        },
                        legend: {
                            show: true,
                            showForSingleSeries: false,
                            showForNullSeries: false,
                            showForZeroSeries: true,
                            position: 'top',
                            horizontalAlign: 'center',
                            floating: false,
                            fontSize: '14px',
                            fontWeight: 400,
                            markers: {
                                width: 25,
                                height: 12,
                                strokeWidth: 0,
                                strokeColor: '#fff',
                                radius: 12,
                                offsetX: 0,
                                offsetY: 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 5
                            },
                        },

                        markers: {
                            size: [4],
                        },

                        plotOptions: {
                            bar: {
                                horizontal: false,
                                startingShape: 'flat',
                                endingShape: 'flat',
                                columnWidth: '40%',
                                distributed: false,
                                rangeBarOverlap: true,
                                rangeBarGroupRows: false,
                                colors: {
                                    ranges: [{
                                        from: 0,
                                        to: 0,
                                        color: '#000'
                                    }],
                                    backgroundBarColors: [],
                                    backgroundBarOpacity: 1,
                                    backgroundBarRadius: 0,
                                },
                                dataLabels: {
                                    enabled: true,
                                    position: 'top',
                                    textAnchor: 'top',
                                    style: {
                                        fontSize: '10px',
                                        fontWeight: 'bold',

                                    },
                                },
                            }
                        },
                        xaxis: {
                            categories: lstRejectionLabel,
                            labels: {
                                rotate: -45,
                                show: true,

                            },
                            axisTicks: {
                                show: false,
                            },
                            title: {
                                text: this.state.xAxis,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                        },
                        yaxis: [{
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#000'
                            },
                            labels: {
                                style: {
                                    color: '#000',
                                    fontSize: 13
                                }
                            },
                            title: {
                                text: 'Count',
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                            tooltip: {
                                enabled: false
                            }

                        }]
                    },
                    countRejectYardage: response.data.countRejectYardage,
                })
            } else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg === 'You are not logged in') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
                else if (response.data.SvcMsg === 'Your Session is expired, login again') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            this.setState({ loader: 'none', opacity: 1 });
            toast.error("Service failed " + error);
        });

    }
    getWorkDoneData = async () => {
        await axiosInstance.post(httpURL+'/a/report/admn_dashboard/machine_type/graph',
            queryString.stringify({ 'duration': this.state.duration }), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                lstMachineData = response.data.lstMachineData;
                lstMachineLabel = response.data.lstLabel;

                workDoneSeries = [];
                for (let i = 0; i < lstMachineData.length; i++) {
                    let obj = lstMachineData[i];
                    let dataObj = { 'name': obj.machineName, 'type': 'line', 'data': obj.lstMachineData }
                    workDoneSeries.push(dataObj);
                }
                console.log(workDoneSeries);

                this.setState({
                    workDoneSeries: workDoneSeries,
                    workDoneOption: {
                        chart: {
                            height: 500,
                            type: 'line',
                            toolbar: {
                                show: false,
                            }
                        },
                        stroke: {
                            width: 3,
                            show: true,
                            dashArray: 0,
                            lineCap: 'butt',
                        },
                        legend: {
                            show: false,
                            showForSingleSeries: false,
                            showForNullSeries: true,
                            showForZeroSeries: true,
                            position: 'bottom',
                            horizontalAlign: 'left',
                            floating: false,
                            fontSize: '14px',
                            fontWeight: 400,
                            markers: {
                                width: 25,
                                height: 12,
                                strokeWidth: 0,
                                strokeColor: '#fff',
                                radius: 12,
                                offsetX: 0,
                                offsetY: 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 5
                            },
                        },
                        markers: {
                            size: [4, 4, 4, 4, 4],
                            width: 12,
                            height: 12,
                        },
                        // title: {
                        //     text: 'Class wise Enquiry',
                        //     align: 'center',
                        // },
                        dataLabels: {
                            enabled: false,
                            enabledOnSeries: [0],
                            style: {
                                fontSize: '15px',
                                fontWeight: 'bold',
                            },
                        },


                        xaxis: {
                            categories: lstMachineLabel,
                            labels: {
                                offsetX: 0,
                                rotate: -45,
                                show: true,
                            },
                            axisTicks: {
                                show: true,
                            },
                            title: {
                                text: this.state.xAxis,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                        },
                        yaxis: [{
                            axisTicks: {
                                show: true,
                            },

                            axisBorder: {
                                show: true,
                                color: '#000'
                            },

                            labels: {
                                style: {
                                    color: '#000',
                                    fontSize: 13
                                },
                                // formatter: function (val) {
                                //     return val.toFixed(0);
                                // }
                            },
                            title: {
                                text: 'Count',
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                            tooltip: {
                                enabled: false
                            }

                        }]
                    },
                })
            } else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg === 'You are not logged in') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
                else if (response.data.SvcMsg === 'Your Session is expired, login again') {
                    setTimeout(function () { window.location.href = ('/') }, 2000);
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            this.setState({ loader: 'none', opacity: 1 });
            toast.error("Service failed " + error);
        });

    }

    view = () => {
        alert("Work in progress");
    }




    // view = (e) => {
    //     window.location.hash = "#detailsContainer";
    //     var adminReportRQ = { laundryId, adminId, 'fromDt': fromDate, 'toDt': toDate };


    //     if ($(e.currentTarget).attr('id') === 'view_order_dtls') {
    //         axiosInstance.post(httpURL + '/admin/dashboard/order_details',
    //             queryString.stringify({ 'adminReportRQ': JSON.stringify(adminReportRQ) }), { withCredentials: true }
    //         ).then((response) => {
    //             if (response.data.SvcStatus === "Success") {
    //                 lstOrderDtls = response.data.lstOrderDtls;
    //                 this.setOrderDetailsTable();
    //                 $('.orderDetailsWrapper').slideDown();
    //                 $('.collectionDetailsWrapper , .expenseDetailsWrapper').slideUp();
    //                 window.location.hash = '#detailsContainer';
    //             }
    //             else {
    //                 toast.error(response.data.SvcMsg)
    //                 if (response.data.SvcMsg === 'You are not Logged In') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //                 else if (response.data.SvcMsg === 'Server Timed Out, Login Again') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //             }
    //             this.setState({ loader: 'none', opacity: 1 });
    //         }).catch((e) => {
    //             toast.error("Service failed " + e);
    //         });
    //     } else if ($(e.currentTarget).attr('id') === 'view_collection_dtls') {
    //         axiosInstance.post(httpURL + '/admin/dashboard/collection_details',
    //             queryString.stringify({ 'adminReportRQ': JSON.stringify(adminReportRQ) }), { withCredentials: true }
    //         ).then((response) => {
    //             if (response.data.SvcStatus === "Success") {
    //                 lstCollectionDtls = response.data.lstCollectionDtls;
    //                 this.setCollectionDetailsTable();
    //                 $('.collectionDetailsWrapper').slideDown();
    //                 $('.expenseDetailsWrapper , .orderDetailsWrapper').slideUp();
    //                 window.location.hash = '#detailsContainer';
    //             }
    //             else {
    //                 toast.error(response.data.SvcMsg)
    //                 if (response.data.SvcMsg === 'You are not Logged In') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //                 else if (response.data.SvcMsg === 'Server Timed Out, Login Again') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //             }
    //             this.setState({ loader: 'none', opacity: 1 });
    //         }).catch((e) => {
    //             toast.error("Service failed " + e);
    //         });
    //     } else if ($(e.currentTarget).attr('id') === 'view_expense_dtls') {
    //         axiosInstance.post(httpURL + '/admin/dashboard/expense_details',
    //             queryString.stringify({ 'adminReportRQ': JSON.stringify(adminReportRQ) }), { withCredentials: true }
    //         ).then((response) => {
    //             if (response.data.SvcStatus === "Success") {
    //                 lstExpenseDtls = response.data.lstExpenseDtls;
    //                 this.setExpenseDetailsTable();
    //                 $('.expenseDetailsWrapper').slideDown();
    //                 $('.collectionDetailsWrapper , .orderDetailsWrapper').slideUp();
    //                 window.location.hash = '#detailsContainer';
    //             }
    //             else {
    //                 toast.error(response.data.SvcMsg)
    //                 if (response.data.SvcMsg === 'You are not Logged In') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //                 else if (response.data.SvcMsg === 'Server Timed Out, Login Again') {
    //                     setTimeout(function () { window.location.href = ('/admin') }, 2000);
    //                     return false;
    //                 }
    //             }
    //             this.setState({ loader: 'none', opacity: 1 });
    //         }).catch((e) => {
    //             toast.error("Service failed " + e);
    //         });
    //     }
    // }

    download = (e) => {
        alert("Work in progress");

        // let httpURL = "http://laundry.kmsgtech.com:12136/laundry";
        // if ($(e.currentTarget).attr('id') === 'download_order_dtls') {
        //     window.location.href = httpURL + '/admin/dashboard/order/download?fromDt='+fromDate+"&toDt="+toDate;

        // } else if ($(e.currentTarget).attr('id') === 'download_collection_dtls') {
        //     window.location.href = httpURL + '/admin/dashboard/collection/download?fromDt='+fromDate+"&toDt="+toDate;

        // } else if ($(e.currentTarget).attr('id') === 'download_expense_dtls') {
        //     window.location.href = httpURL + '/admin/dashboard/expense/download?fromDt='+fromDate+"&toDt="+toDate;

        // }
    }




    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <ToastContainer autoClose={2000} hideProgressBar />
                <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
                    <img className="loderImg" src={require("./../../images/loader.gif")} alt="Loader..." />
                </div>
                <div className="main adminDashboardGraphs" style={{ opacity: this.state.opacity }}>
                    <div className="container-fluid">
                        <div className="col-xs-12 tab">
                            <div className="col-sm-6 tabSection weekly" onClick={this.setDurationWeekly}>
                                Weekly
                            </div>
                            <div className="col-sm-6 tabSection monthly" onClick={this.setDurationMonthly}>
                                Monthly
                            </div>
                        </div>
                        <div className="col-xs-12 clearfix">
                            <div className="col-xs-12 dataSummaryWrap">
                                <div className="col-xs-6 dataSummaryBlock">
                                    <CountData
                                        summeryTitle="New Ipo"
                                        countData={this.state.countNewIpo}
                                        options={this.state.newIpoOption}
                                        series={this.state.newIpoSeries}
                                        graphType="bar"
                                    />
                                    <div className="col-xs-12 summaryDocs">
                                        <i className="glyphicon glyphicon-eye-open" id="view_order_dtls" onClick={this.view}><span>View</span></i>
                                        <i className="glyphicon glyphicon-download" id="download_order_dtls" onClick={this.download}><span>Download</span></i>
                                    </div>
                                </div>
                                <div className="col-xs-6 dataSummaryBlock">
                                    <CountData
                                        summeryTitle="Rejection"
                                        countData={this.state.countRejectYardage}
                                        options={this.state.rejectionOption}
                                        series={this.state.rejectionSeries}
                                        graphType="bar"
                                    />
                                    <div className="col-xs-12 summaryDocs">
                                        <i className="glyphicon glyphicon-eye-open" id="view_collection_dtls" onClick={this.view}><span>View</span></i>
                                        <i className="glyphicon glyphicon-download" id="download_collection_dtls" onClick={this.download}><span>Download</span></i>
                                    </div>
                                </div>
                                <div className="col-xs-6 dataSummaryBlock">
                                    <CountData
                                        summeryTitle="Work Done"
                                        countData={this.state.workDoneCount}
                                        options={this.state.workDoneOption}
                                        series={this.state.workDoneSeries}
                                        graphType="line"
                                    />
                                    <div className="col-xs-12 summaryDocs">
                                        <i className="glyphicon glyphicon-eye-open" id="view_expense_dtls" onClick={this.view}><span>View</span></i>
                                        <i className="glyphicon glyphicon-download" id="download_expense_dtls" onClick={this.download}><span>Download</span></i>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div >
        );
    }
}


export default AdminDashboard;
